import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const GenericWarningMarkIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="50" height="50" viewBox="0 0 512 512">
		<g transform="translate(-2.5 -2.5)">
			<path
				d="M256,30C131.383,30,30,131.383,30,256S131.383,482,256,482,482,380.617,482,256,380.617,30,256,30m0-30C397.385,0,512,114.615,512,256S397.385,512,256,512,0,397.385,0,256,114.615,0,256,0Z"
				transform="translate(2.5 2.5)"
				opacity="0.3"
			/>
			<path
				d="M0,216.392V103.468a22.361,22.361,0,0,1,44.722,0V216.392a22.361,22.361,0,1,1-44.722,0ZM0,22.361A22.361,22.361,0,1,1,22.361,44.722,22.361,22.361,0,0,1,0,22.361Z"
				transform="translate(280.5 377.5) rotate(180)"
			/>
		</g>
	</svg>
);
